<template>
  <div class="layout-index-steps">
    <div class="container">
      <div class="title s-36 w-500"><slot name="title"></slot></div>
      <div class="subtitle s-18"><slot name="subtitle"></slot></div>
      <div class="steps">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-index-steps {
  margin: 5em 0;
  text-align: center;
}
.title {
  margin-bottom: 0.5em;
}
.subtitle {
  width: 600px;
  max-width: 100%;
  display: inline-block;
}
.steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 4em;
  gap: 40px;
  img {
    margin: auto;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 767px) {
  .layout-index-steps {
    padding: 0 15px;
    .steps {
      display: block;
      & > * {
        margin-bottom: 2em;
      }
    }
  }
}
</style>
